(function () {
  var root = document.querySelector('[data-gpdp]');
  if (!root) return;

  var VID = parseInt(root.dataset.variantId, 10);
  var VARIANTS = JSON.parse(root.dataset.variants || '[]');
  var CURRENCY = root.dataset.currency || 'EUR';
  var _initV = VARIANTS.find(function (v) { return v.id === VID; });
  window.GROW_SELECTED_VID = VID;

  window.swapImage = function (thumb, src) {
    root.querySelectorAll('.gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var img = root.querySelector('#gpdp-main-img');
    if (img && src) img.src = src;
  };

  var UNIT_PRICE = _initV ? _initV.price : null;

  function setAtcPrice(unitPrice) {
    UNIT_PRICE = unitPrice;
    var qty = parseInt((root.querySelector('#qty') || {}).textContent || '1', 10);
    var sp = root.querySelector('#gpdp-atc-price');
    if (!sp) return;
    var fmt = function (p) { return (p / 100).toLocaleString('fr-FR', { style: 'currency', currency: CURRENCY }); };
    if (qty >= 2) {
      var total = unitPrice * qty;
      var paid  = unitPrice * Math.ceil(qty / 2);
      sp.innerHTML = '<s>' + fmt(total) + '</s> ' + fmt(paid);
    } else {
      sp.textContent = fmt(unitPrice);
    }
  }

  window.updateQty = function (delta) {
    var el = root.querySelector('#qty');
    el.textContent = Math.max(1, Math.min(5, parseInt(el.textContent, 10) + delta));
    if (UNIT_PRICE !== null) setAtcPrice(UNIT_PRICE);
  };

  window.addToCart = function (forcedQty) {
    var qty = forcedQty || parseInt((root.querySelector('#qty') || {}).textContent || '1', 10) || 1;
    root.querySelectorAll('.cta-main').forEach(function (btn) {
      var origHTML = btn.innerHTML;
      btn.innerHTML = (window.growStrings && window.growStrings.added) || '✓ Ajouté';
      btn.style.cssText = 'background:#0F0F0F;color:#fff';
      setTimeout(function () { btn.innerHTML = origHTML; btn.style.cssText = ''; }, 2000);
    });
    var paidQty = Math.ceil(qty / 2);
    // La/les paire(s) offerte(s) ne sont jamais ajoutées automatiquement avec le même modèle :
    // le cart drawer se charge de proposer le choix parmi les 93 montures éligibles.
    var cartItems = [{ id: VID, quantity: paidQty }];
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status && res.status >= 400) return;
      if (window.CasaCart) window.CasaCart.open();
    })
    .catch(function (e) { console.error('[GROW ATC]', e); });
  };

  window.gpdpSwatch = function (btn) {
    root.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
    btn.classList.add('active');
    var lbl = root.querySelector('#gpdp-color-label');
    if (lbl) lbl.textContent = btn.getAttribute('aria-label');

    var colorVal = btn.dataset.color;
    var colorPos = parseInt(btn.dataset.optPosition || '1', 10);
    var currentV = VARIANTS.find(function (v) { return v.id === VID; });

    var matched = VARIANTS.find(function (v) {
      if (v['option' + colorPos] !== colorVal) return false;
      if (!currentV) return true;
      for (var i = 1; i <= 3; i++) {
        if (i === colorPos) continue;
        if (v['option' + i] !== currentV['option' + i]) return false;
      }
      return true;
    });
    if (!matched) matched = VARIANTS.find(function (v) { return v['option' + colorPos] === colorVal; });

    if (matched) {
      VID = matched.id;
      window.GROW_SELECTED_VID = VID;
      var fmtS = (matched.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: CURRENCY });
      var pe = root.querySelector('#gpdp-price');
      if (pe) pe.textContent = fmtS;
      var sp = root.querySelector('#gpdp-sticky-price');
      if (sp) sp.textContent = fmtS;
      setAtcPrice(matched.price);
      if (matched.featured_image) {
        var mainImg = root.querySelector('#gpdp-main-img');
        if (mainImg) mainImg.src = matched.featured_image.src;
        var stickyImg = root.querySelector('#gpdp-sticky-img');
        if (stickyImg) stickyImg.src = matched.featured_image.src;
      }
    }

    root.querySelectorAll('.gallery__thumb--swatch').forEach(function (t) {
      t.classList.toggle('active', t.dataset.color === colorVal);
    });

    if (matched) updateAtcState(matched);
  };

  window.gpdpSwatchByVal = function (colorVal, colorPos) {
    var btn = null;
    root.querySelectorAll('.swatch[data-color]').forEach(function (s) {
      if (s.dataset.color === colorVal) btn = s;
    });
    if (btn) gpdpSwatch(btn);
  };

  window.gpdpSize = function (btn, vid, label) {
    root.querySelectorAll('.size').forEach(function (s) { s.classList.remove('active'); });
    btn.classList.add('active');
    var lbl = root.querySelector('#gpdp-size-label');
    if (lbl) lbl.textContent = label;
    var sl = root.querySelector('#gpdp-sticky-size');
    if (sl) sl.textContent = label;
    if (vid) {
      VID = vid;
      window.GROW_SELECTED_VID = VID;
      var v = VARIANTS.find(function (x) { return x.id === vid; });
      if (v) {
        var fmtV = (v.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: CURRENCY });
        var pe = root.querySelector('#gpdp-price');
        if (pe) pe.textContent = fmtV;
        var sp = root.querySelector('#gpdp-sticky-price');
        if (sp) sp.textContent = fmtV;
        setAtcPrice(v.price);
        updateAtcState(v);
      }
    }
  };

  function updateAtcState(v) {
    var available = v ? v.available : true;
    var atcBtn = root.querySelector('#gpdp-atc');
    var stickyBtn = root.querySelector('#gpdp-sticky-atc');

    if (atcBtn) {
      if (!available) {
        if (!atcBtn.dataset.origHtml) atcBtn.dataset.origHtml = atcBtn.innerHTML;
        atcBtn.innerHTML = 'Rupture de stock';
        atcBtn.disabled = true;
        atcBtn.onclick = null;
      } else {
        if (atcBtn.dataset.origHtml) {
          atcBtn.innerHTML = atcBtn.dataset.origHtml;
          delete atcBtn.dataset.origHtml;
          setAtcPrice(v.price);
        }
        atcBtn.disabled = false;
        atcBtn.onclick = window.addToCart;
      }
    }

    if (stickyBtn) {
      if (!available) {
        stickyBtn.textContent = 'Rupture de stock';
        stickyBtn.disabled = true;
        stickyBtn.onclick = null;
      } else {
        stickyBtn.textContent = (window.growStrings && window.growStrings.addToCart) || 'Ajouter au panier';
        stickyBtn.disabled = false;
        stickyBtn.onclick = window.addToCart;
      }
    }
  }

  var DUO_VID = null;

  window.duoPick = function (el, name, imgSrc) {
    root.querySelectorAll('.duo-mini__choice').forEach(function (c) { c.classList.remove('is-active'); });
    el.classList.add('is-active');
    DUO_VID = parseInt(el.dataset.variantId, 10) || VID;
    var nameEl = root.querySelector('#duo-b-name');
    var imgEl  = root.querySelector('#duo-b-img');
    var phEl   = root.querySelector('#duo-b-ph');
    var ctaEl  = root.querySelector('#duo-cta');
    if (nameEl) { nameEl.textContent = name; nameEl.style.color = ''; }
    if (imgSrc && imgEl) { imgEl.src = imgSrc; imgEl.style.display = 'block'; }
    if (phEl) phEl.style.display = 'none';
    if (ctaEl) {
      ctaEl.disabled = false;
      var enabledText = ctaEl.dataset.enabledText;
      if (enabledText) ctaEl.textContent = enabledText;
    }
  };

  window.addDuoToCart = function () {
    var items = [{ id: VID, quantity: 1 }];
    if (DUO_VID && DUO_VID !== VID) items.push({ id: DUO_VID, quantity: 1 });
    var btn = root.querySelector('#duo-cta');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = (window.growStrings && window.growStrings.duoAdded) || '✓ Duo ajouté'; btn.disabled = true; }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      setTimeout(function () { if (btn) { btn.innerHTML = orig; btn.disabled = false; } }, 2000);
      if (res.status && res.status >= 400) return;
      if (window.CasaCart) window.CasaCart.open();
    })
    .catch(function (e) { console.error('[GROW DUO]', e); });
  };

  var swatchWraps = root.querySelectorAll('.swatches-wrap');
  if (swatchWraps.length) {
    swatchWraps.forEach(function (wrap) {
      var track = wrap.querySelector('.swatches');
      if (!track) return;
      var refresh = function () {
        var overflowing = track.scrollWidth > track.clientWidth + 1;
        wrap.classList.toggle('no-scroll', !overflowing);
        wrap.classList.toggle('at-scroll-end', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
      };
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    });
  }
})();
